import { module } from 'modujs';
import { html } from '../utils/environment';
import modularLoad from '../utils/load';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.load = new modularLoad({
            enterDelay: 400,
            transitions: {
                filter: {
                    enterDelay: 400,
                    exitDelay: 400
                }
            }
        });

        this.load.on('loading', (transition, oldContainer) => {
            html.classList.remove('has-scrolled');
            this.call('close', null, 'Menu')
            this.call('close', null, 'Cart')
            this.call('close', null, 'Search')

            if(transition === 'filter') {
                this.call('scrollTo', [document.getElementById('page'), 0], 'Scroll')
            }
        });

        this.load.on('loaded', (transition, oldContainer, newContainer) => {

            this.call('destroy', oldContainer, 'app');
            this.call('update', newContainer, 'app');

            if(window.ShopifyAnalytics) {
                window.ShopifyAnalytics.lib.page();
            }

            if(transition === 'filter') {
                setTimeout(() => {
                    this.call('update', null, 'Scroll')
                },600)
            }

            // Fetch any inline script elements.
            // const scripts = newContainer.querySelectorAll('script');
            // console.log(scripts)

            // if (scripts instanceof window.NodeList) {
            //     let i = 0;
            //     let len = scripts.length;
            //     for (; i < len; i++) {
            //         if(scripts[i].type != "application/json") {
            //             console.log(scripts[i])
            //             eval(scripts[i].innerHTML);
            //         }
            //     }
            // }
        });
    }

    goTo(param) {
        this.load.goTo(param[0], param[1])
    }
}
